import React from 'react'
import './styles.sass'

export function Spinner () {
  return <div className="loader">Loading...</div>
}
